import { ModulePlaceholderList } from '../../components/ModulePlaceholderList';

export default function AllExits() {
  return (
    <ModulePlaceholderList
      title="Exit cases"
      newPath="/panel/exits/new"
      newLabel="New exit case"
    />
  );
}
